import '../../chunks/chunk-525a49bc.js';
import 'antd';
import 'react';
import 'styled-components';
import '../../chunks/chunk-bc685b06.js';
import '../../chunks/chunk-53391a7d.js';
import '../../chunks/chunk-c2b06a8e.js';
import '../../chunks/chunk-6cec2b98.js';
import { f as withTimeseries } from '../../chunks/chunk-2f6aabaf.js';
import '../../chunks/chunk-e1ac37a6.js';
import 'moment';
import '../TimeseriesChart/index.js';
import '@cognite/griff-react';
import '../../chunks/chunk-65cf8e1d.js';
import 'numeral';
import { T as TimeseriesChartMetaPure } from '../../chunks/chunk-94869f39.js';

// Copyright 2020 Cognite AS
var TimeseriesChartMeta = withTimeseries(TimeseriesChartMetaPure);

export { TimeseriesChartMeta };
